import { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { AppDrawer } from './appdrawer';
import { BreadCrumbs } from '@/components/breadcrumbs';
import { Stack } from '@mui/system';

export const RootLayout = (props: PropsWithChildren) => {
	return (
		<Box
			component='main'
			display='flex'
			flex={1}>
			<AppDrawer />
			<Stack width='100%'>
				<BreadCrumbs />
				<Box
					display='flex'
					flexGrow={1}
					width='100%'>
					{props.children}
				</Box>
			</Stack>
		</Box>
	);
};
